module.exports = __webpack_public_path__ + "static/media/raja1.ff0e6e25.png";